import Alpine from 'alpinejs'

Alpine.store('basket', { data: '' })
Alpine.store('suggestedProducts', { data: '' })
Alpine.store('checkout', { data: '' })
